import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const DeletePromptIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <rect width="16" height="16" rx="8" fill={fillColor || 'black'} />
      <g clipPath="url(#clip0_1165_5531)">
        <path d="M3.5 5H12.5" stroke={fillColor || '#9D9DA6'} strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M11.5 5V11.5625C11.5 12.0312 11 12.5 10.5 12.5H5.5C5 12.5 4.5 12.0312 4.5 11.5625V5"
          stroke={fillColor || '#9D9DA6'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6 5V4C6 3.5 6.5 3 7 3H9C9.5 3 10 3.5 10 4V5"
          stroke={fillColor || '#9D9DA6'}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M7 8V10" stroke={fillColor || '#9D9DA6'} strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 8V10" stroke={fillColor || '#9D9DA6'} strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1165_5531">
          <rect width="12" height="12" fill={fillColor || 'white'} transform="translate(2 2)" />
        </clipPath>
      </defs>
    </svg>
  );
};

export { DeletePromptIcon };
